import pedidoVentaService, { type PedidoVentaDetalle } from '../services/pedidoVentaService';
import { umDesdeDetalleTransaccion } from './umVentaDocumento';
import {
  cantidadBase,
  cantidadUmIngresoFromSnapshot,
  showExtraPedFac,
} from './umDocumentoDisplay';

function detallePedidoMatch(
  detalles: PedidoVentaDetalle[],
  nroItemMaster?: number | null,
  codigoArticulo?: string,
): PedidoVentaDetalle | undefined {
  const nim = Number(nroItemMaster);
  let line =
    Number.isFinite(nim) && nim > 0
      ? detalles.find((d) => Number(d.nroItem) === nim)
      : undefined;
  const cod = String(codigoArticulo ?? '').trim();
  if (!line && cod) {
    line = detalles.find((d) => String(d.codigoArticulo ?? '').trim() === cod);
  }
  return line;
}

/** Recupera la UM de ingreso del pedido origen (snapshot Ped si hay equivalencia; si no, base). */
export async function umDesdePedidoMaster(
  nroFormularioMaster?: number | null,
  nroItemMaster?: number | null,
  codigoArticulo?: string,
): Promise<string> {
  const nfm = Number(nroFormularioMaster);
  if (!Number.isFinite(nfm) || nfm <= 0) return '';
  try {
    const pedido = await pedidoVentaService.getPedidoVenta(nfm);
    const line = detallePedidoMatch(pedido.detalles || [], nroItemMaster, codigoArticulo);
    if (!line) return '';
    const ingreso = cantidadUmIngresoFromSnapshot(line, 'ped');
    return ingreso.um || umDesdeDetalleTransaccion(line);
  } catch {
    return '';
  }
}

/**
 * Convierte cantidad pendiente (en UM base del pedido) a cantidad/UM de ingreso del remito.
 * Si el pedido tiene snapshot Ped distinto de base, el remito debe enviarse en esa UM documental.
 */
export async function cantidadUmIngresoDesdePedidoMaster(
  nroFormularioMaster?: number | null,
  nroItemMaster?: number | null,
  codigoArticulo?: string,
  cantidadPendienteBase?: number,
): Promise<{ cantidad: number; um: string } | null> {
  const nfm = Number(nroFormularioMaster);
  const cantBasePend = Number(cantidadPendienteBase);
  if (!Number.isFinite(nfm) || nfm <= 0 || !Number.isFinite(cantBasePend) || cantBasePend <= 0) {
    return null;
  }
  try {
    const pedido = await pedidoVentaService.getPedidoVenta(nfm);
    const line = detallePedidoMatch(pedido.detalles || [], nroItemMaster, codigoArticulo);
    if (!line) return null;

    const ingreso = cantidadUmIngresoFromSnapshot(line, 'ped');
    const baseLinea = cantidadBase(line);
    if (!showExtraPedFac(line, 'ped') || !(baseLinea > 0) || !(ingreso.cantidad > 0)) {
      return { cantidad: cantBasePend, um: ingreso.um || umDesdeDetalleTransaccion(line) };
    }

    // Proporción: pendienteBase / baseLínea * cantidadDocLínea
    const cantidadDoc = (cantBasePend / baseLinea) * ingreso.cantidad;
    return { cantidad: cantidadDoc, um: ingreso.um };
  } catch {
    return null;
  }
}
